
export default {
	tabs: {
		info: 'بيانات الموظف',
		'work-and-Vacations': 'العمل والدوام',
		records: 'الوقوعات الوظيفية',
		interviews: 'المقبلات والتقيمات',
		penaltiesAndRewards: 'العقوبات والمكافئات',
		complains: 'الشكوى',
		salaries: 'الرواتب',
		covenant: 'العهد',
		complaints: 'الشكاوي',
		'employee-training': 'سجل التدريبات',
		'employee-salary': 'الراتب'
	},
};
